import i18n from '../i18n';

/**
 * Date format
 */
['en', 'fr'].forEach((locale) => {
  i18n.setDateTimeFormat(locale, {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  });
});

/**
 * Number format
 */
i18n.setNumberFormat('en', {
  currency: {
    style: 'currency',
    currency: 'USD',
  },
});
i18n.setNumberFormat('fr', {
  currency: {
    style: 'currency',
    currency: 'EUR',
  },
});
